<section ngClass.lt-sm="small">
  <div class="title-container" fxLayout="row">
    <h2 fxFlex="1 1 auto" class="left-title">Gemeinsam!</h2>
    <h2 fxHide.lt-md class="center-title">Von der Idee zum Shop</h2>
    <h2 fxHide.lt-md fxFlex="1 1 auto" class="center-clone">Gemeinsam!</h2>
  </div>
  <div fxLayout="column" fxLayoutAlign="center center" fxLayoutGap="40px">
    <div class="paragraph" fxLayout="row" fxLayout.lt-sm="column-reverse" fxLayoutAlign="center center"
         fxLayoutGap="20px">
      <div fxLayout="column" fxLayoutAlign="center start">
        <h3>ABC Complett Ladeneinrichtungs GmbH</h3>
        <p>Wir bieten Dir Deinen unverwechselbaren Shop. Im Shoppingcenter oder an der Strasse – von kleinem Imbiss bis
          zum großartigen Showroom.</p>
        <p>Die Finanzierung von Neubau- und Umbauprojekten spielt eine immer größere Rolle – hier stellen wir gern den
          Kontakt zu Finanzierern her.</p>
      </div>
      <img class="left" [ngClass.lt-sm]="{'align-center': true}"
           defaultImage="../../../assets/images/ui/image-placeholder.png"
           lazyLoad="../../../assets/images/warumwir/eroeffnung.jpg"/>
    </div>
    <div class="paragraph" fxLayout="row-reverse" fxLayout.lt-sm="column-reverse" fxLayoutAlign="center center"
         fxLayoutGap="20px">
      <div class="text-right" fxLayout="column" fxLayoutAlign="center end">
        <h3>Das Portemonnaie des Endkunden</h3>
        <p>Mit unserer Hilfe setzt Du Dich im Wettbewerb um das Portemonnaie des Endkunden durch.</p>
        <p>Nutze unser Fachwissen und über 25 Jahre Erfahrung im Bereich Ladeneinrichtung - so unterstützen wir Dich bei
          Deinem geschäftlichen Erfolg.</p>
      </div>
      <img [ngClass.lt-sm]="{'align-center': true}"
           defaultImage="../../../assets/images/ui/image-placeholder.png"
           lazyLoad="../../../assets/images/warumwir/portemonnaie.jpg"/>
    </div>
    <div class="paragraph" fxLayout="row" fxLayout.lt-sm="column-reverse" fxLayoutAlign="center center"
         fxLayoutGap="20px">
      <div fxLayout="column" fxLayoutAlign="center start">
        <h3>Auf die Mischung kommt es an</h3>
        <p>Wir planen und realisieren Dein persönliches Fachgeschäft. Deine Wünsche und Ideen stehen dabei im
          Mittelpunkt.</p>
        <p>Dein Shop setzt sich aus einer Mischung kostengünstiger Systemteile und individueller Einzelanfertigung
          zusammen. Das schafft ein überaus günstiges Preis-/ Leistungsverhältnis.</p>
      </div>
      <img class="left" [ngClass.lt-sm]="{'align-center': true}"
           defaultImage="../../../assets/images/ui/image-placeholder.png"
           lazyLoad="../../../assets/images/warumwir/planungsgespraech.jpg"/>
    </div>
    <div class="paragraph" fxLayout="row-reverse" fxLayout.lt-sm="column-reverse" fxLayoutAlign="center center"
         fxLayoutGap="20px">
      <div class="text-right" fxLayout="column" fxLayoutAlign="center end">
        <h3>Ein Ansprechpartner – Ein Preis</h3>
        <p>Auf Wunsch liefern wir alle Gewerke und Leistungen zum fairen Festpreis. Wir arbeiten zuverlässig und
          schnell. Du hast EINEN persönlichen Ansprechpartner für alle Belange rund um den Ladenbau.</p>
        <p>Wir sind für Dich da.</p>
      </div>
      <img [ngClass.lt-sm]="{'align-center': true}"
           defaultImage="../../../assets/images/ui/image-placeholder.png"
           lazyLoad="../../../assets/images/warumwir/handwerker.jpg"/>
    </div>
    <div class="paragraph" fxLayout="row" fxLayout.lt-sm="column-reverse" fxLayoutAlign="center center"
         fxLayoutGap="20px">
      <div fxLayout="column" fxLayoutAlign="center start">
        <h3>Wir freuen uns auf Dich.</h3>
        <p>Du hast eine Anfrage, bei deren Lösung wir Dir helfen können? Gern stehen wir Dir im Rahmen eines konkreten
          Projektes mit Rat und Tat zur Seite.</p>
        <p>Ruf uns an: <a class="link" [routerLink]="['/dialog/telefon']">030 85 99 71 - 0</a>,
          sende uns eine <a class="link" href="mailto:kontakt@abc-complett.de">E-Mail</a>
          oder nutze am besten gleich unser <span class="link" (click)="openContactDialog()">Kontaktformular
        </span>.</p>
        <p>Wir freuen uns auf Dich.</p>
      </div>
      <img class="left" [ngClass.lt-sm]="{'align-center': true}"
           defaultImage="../../../assets/images/ui/image-placeholder.png"
           lazyLoad="../../../assets/images/warumwir/vertragsabschluss.jpg"/>
    </div>
  </div>
</section>
